import { render } from "./CrLabel.vue?vue&type=template&id=70d39076&scoped=true"
import script from "./CrLabel.vue?vue&type=script&lang=js"
export * from "./CrLabel.vue?vue&type=script&lang=js"

import "./CrLabel.vue?vue&type=style&index=0&id=70d39076&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d39076"]])

export default __exports__